import React from 'react';
import { Box, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ViewListIcon from '@material-ui/icons/ViewList';
import ViewModuleIcon from '@material-ui/icons/ViewModule';

// Alternador Tabela ⇄ Cartões, partilhado por todos os ecrãs de lista do
// backoffice. A escolha é lembrada por ecrã (localStorage), para o operador
// não ter de a repetir.
//
//   const [view, setView] = useAdminView('clients');   // 'table' | 'cards'
//   <AdminViewToggle view={view} onChange={setView} />

const KEY = (page) => `admin_view_${page}`;

export function useAdminView(page, fallback = 'table') {
  const [view, setView] = React.useState(() => {
    try { return localStorage.getItem(KEY(page)) || fallback; } catch { return fallback; }
  });
  const update = React.useCallback((v) => {
    setView(v);
    try { localStorage.setItem(KEY(page), v); } catch { /* ignora */ }
  }, [page]);
  return [view, update];
}

const useStyles = makeStyles(() => ({
  wrap: {
    display: 'inline-flex',
    background: 'var(--adm-card, #ffffff)',
    border: '1.5px solid var(--adm-card-border, #d9e6df)',
    borderRadius: 10,
    padding: 3,
    gap: 2,
  },
  btn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 34,
    height: 30,
    borderRadius: 7,
    cursor: 'pointer',
    color: 'var(--adm-text-muted, #94a3b8)',
    transition: 'all 0.18s ease',
    '&:hover': { background: 'var(--adm-brand-soft, #eef5f1)', color: 'var(--adm-brand, #2f5d50)' },
  },
  btnOn: {
    background: 'var(--adm-brand, #2f5d50)',
    color: 'var(--adm-on-brand, #c3f53c)',
    '&:hover': { background: 'var(--adm-brand-dark, #274c41)', color: 'var(--adm-on-brand, #c3f53c)' },
  },
}));

export default function AdminViewToggle({ view, onChange }) {
  const classes = useStyles();
  return (
    <Box className={classes.wrap}>
      <Tooltip title="Vista de tabela" arrow>
        <Box
          className={`${classes.btn} ${view === 'table' ? classes.btnOn : ''}`}
          onClick={() => onChange('table')}
        >
          <ViewListIcon style={{ fontSize: 18 }} />
        </Box>
      </Tooltip>
      <Tooltip title="Vista de cartões" arrow>
        <Box
          className={`${classes.btn} ${view === 'cards' ? classes.btnOn : ''}`}
          onClick={() => onChange('cards')}
        >
          <ViewModuleIcon style={{ fontSize: 18 }} />
        </Box>
      </Tooltip>
    </Box>
  );
}
